import { render, staticRenderFns } from "./ap-vendoriq.vue?vue&type=template&id=dbe8fd40&scoped=true"
import script from "./ap-vendoriq.vue?vue&type=script&lang=js"
export * from "./ap-vendoriq.vue?vue&type=script&lang=js"
import style0 from "./ap-vendoriq.vue?vue&type=style&index=0&id=dbe8fd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe8fd40",
  null
  
)

export default component.exports